import { cn } from '@/utils/tailwind-util';
import { InformationCircleIcon } from '@heroicons/react/solid/index';
import { styled } from 'styled-components';

const toastWidth = { mobile: '300px', web: '335px' };

const Container = ({ position, children }) => {
  return (
    <ul
      className={cn(
        'absolute text-white z-9999',
        position === 'topCenter' && 'left-[calc((100%-335px)/2)] top-0 mt-2',
        position === 'topRight' && 'top-0 right-0 mr-2 mt-2',
        position === 'bottomRight' && 'bottom-0 right-0 mr-2 mb-2',
        position === 'bottomCenter' &&
          'left-[calc((100%-335px)/2)] bottom-0 mb-2'
      )}
    >
      {children}
    </ul>
  );
};

const Toast = styled.li`
  border-radius: 4px;
  margin-bottom: 8px;
  position: relative;
  list-style: none;

  width: ${toastWidth.web};
  padding: 14px;

  animation: ${({ position }) =>
    position === 'bottomCenter'
      ? 'toast-in-bottom 0.7s'
      : 'toast-in-right 0.7s'};
  transition: 0.3s ease;

  & .circle__icon {
    fill: ${({ type }) => {
      if (type === 'warning') {
        return '#f3213b';
      }
    }};
  }

  @keyframes toast-in-right {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }

  @keyframes toast-in-bottom {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }
  color: white;
  background-color: ${({ type }) => {
    if (type === 'success') {
      return '#383940';
    } else if (type === 'error') {
      return '#383940';
    } else if (type === 'info') {
      return '#383940';
    } else if (type === 'warning') {
      return '#1c1c1e';
    }
  }};
`;

const ToastView = ({ list, position, onDeleteToast }) => {
  return (
    <Container position={position}>
      {list.length &&
        list.map((toast, index) => {
          // 동일한 중복 메시지 뜨는것 방지하기 위한 분기처리
          if (index >= 2 && toast.description === list[index - 1].description) {
            return null;
          } else {
            return (
              <Toast key={toast.id} type={toast.type} position={position}>
                <div className="flex">
                  {toast?.showIcon ? (
                    <InformationCircleIcon className="mr-2.5 circle__icon w-5 h-5" />
                  ) : null}
                  <p
                    className={cn(
                      'text-sm font-medium',
                      toast?.showIcon && 'mr-5'
                    )}
                  >
                    {toast.description}
                  </p>
                </div>
                {toast?.closeOnClick && (
                  <button
                    className="absolute right-4 top-[11px]"
                    onClick={() => onDeleteToast(toast.id)}
                  >
                    {toast?.showIcon ? 'x' : 'Close'}
                  </button>
                )}
              </Toast>
            );
          }
        })}
    </Container>
  );
};

export default ToastView;
